/**
 * @description AppFooter company-name SoT (LYN-331)
 *
 * Key features:
 * - Occupancy present: organizationName (CP = channel_partners.name, SO = organization_name)
 * - No occupancy: that tenant's company primitive (companies.business_name)
 * - Never identity.tagline or identity.platformName
 *
 * @dependencies none
 *
 * @notes
 * - Not a Channel Partner layout override — AppFooter reads this for every chrome
 * - Invite From stays platformName (channelPartnerEmail); copyright is this fact
 */

/**
 * @param {{
 *   occupancy?: { kind?: string }|null,
 *   organizationName?: string|null,
 *   businessName?: string|null
 * }} input
 * @returns {string}
 */
export function footerCompanyName({
  occupancy = null,
  organizationName = null,
  businessName = null
} = {}) {
  const org = typeof organizationName === 'string' ? organizationName.trim() : '';
  if (occupancy) {
    return org;
  }
  return typeof businessName === 'string' ? businessName.trim() : '';
}

export default footerCompanyName;
